import { Box, Tooltip } from "@chakra-ui/react";
import React from "react";
import { useSearchParams } from "react-router-dom";

import { RouterLink } from "../../../../components";
import { formatDuration } from "../../../../utils/datetime";
import MonospacedText from "../../MonospacedText";

export type CitationsProps = {
  citations: number[] | null | undefined;
  citationMap: Map<number, number>;
  onClickTimestamp?: (timestamp: number, e: React.MouseEvent) => void;
};

export const Citations: React.FC<CitationsProps> = ({
  citations,
  citationMap,
  onClickTimestamp,
}) => {
  const [searchParams] = useSearchParams();

  if (!citations?.length) {
    return null;
  }
  const uniqueSortedCitations = Array.from(new Set(citations)).toSorted(
    (a, b) => a - b
  );

  return (
    <Box
      as="span"
      display="inline-flex"
      gap="1"
      verticalAlign="top"
      fontSize="2xs"
      ml="1"
    >
      {uniqueSortedCitations.map((citation) => {
        const label = citationMap.get(citation)?.toString();
        if (!label) {
          return null;
        }

        searchParams.set("t", citation.toString());
        const newSearchParams = `?${searchParams.toString()}`;

        return (
          <Tooltip
            key={citation}
            label={formatDuration(Math.round(citation))}
            openDelay={200}
          >
            <RouterLink
              fontWeight="normal"
              to={{ search: newSearchParams }}
              replace
              onClick={(e) => {
                onClickTimestamp?.(citation, e);
              }}
            >
              <MonospacedText
                display="inline-block"
                verticalAlign="super"
                text={label}
              />
            </RouterLink>
          </Tooltip>
        );
      })}
    </Box>
  );
};
